"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uploadSecure = exports.getUploadUrl = exports.postUploadSuccess = exports.searchAddress = exports.triage = exports.TRIAGE_ENDPOINT = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.promise.js");

var _axios = _interopRequireDefault(require("axios"));

var _logger = require("@evidation/logger");

var _utils = require("@evidation/utils");

var _lodash = _interopRequireDefault(require("lodash"));

var TRIAGE_ENDPOINT = _lodash["default"].get(window, 'env.REACT_APP_TRIAGE_ENDPOINT') || window.location.origin;
exports.TRIAGE_ENDPOINT = TRIAGE_ENDPOINT;

var triage = _axios["default"].create({
  baseURL: "".concat(TRIAGE_ENDPOINT, "/api/v3/")
});

exports.triage = triage;

var searchAddress = function searchAddress(_ref) {
  var enrollment_identifier = _ref.enrollment_identifier,
      cancelToken = _ref.cancelToken,
      query = _ref.query,
      take = _ref.take,
      participant_auth_token = _ref.participant_auth_token;
  return triage({
    method: 'POST',
    url: (0, _utils.urlWithQueryParams)("enrollments/".concat(enrollment_identifier, "/addresses/search"), {
      query: query,
      take: take,
      participant_auth_token: participant_auth_token
    }),
    cancelToken: cancelToken
  });
};

exports.searchAddress = searchAddress;

var postUploadSuccess = function postUploadSuccess(_ref2) {
  var interaction_identifier = _ref2.interaction_identifier,
      enrollment_identifier = _ref2.enrollment_identifier,
      participant_auth_token = _ref2.participant_auth_token,
      auth_token = _ref2.auth_token;
  return triage({
    method: "POST",
    url: "/enrollments/".concat(enrollment_identifier, "/files?interaction_identifier=").concat(interaction_identifier, "&auth_token=").concat(auth_token),
    headers: {
      'Participant-Auth-Token': participant_auth_token,
      'Content-Type': 'application/json'
    }
  });
};

exports.postUploadSuccess = postUploadSuccess;

var getUploadUrl = function getUploadUrl(_ref3) {
  var participant_auth_token = _ref3.participant_auth_token,
      auth_token = _ref3.auth_token,
      enrollment_identifier = _ref3.enrollment_identifier,
      node_slug = _ref3.node_slug,
      bucket = _ref3.bucket,
      object_content_type = _ref3.object_content_type,
      _ref3$rand = _ref3.rand,
      rand = _ref3$rand === void 0 ? Math.random() : _ref3$rand;
  return triage({
    method: "GET",
    url: "/enrollments/".concat(enrollment_identifier, "/files/upload_url?node_identifier=").concat(node_slug, "&bucket=").concat(bucket, "&object_content_type=").concat(object_content_type, "&auth_token=").concat(auth_token, "&rand=").concat(rand),
    headers: {
      'Participant-Auth-Token': participant_auth_token
    }
  });
};

exports.getUploadUrl = getUploadUrl;

var uploadSecure = /*#__PURE__*/function () {
  var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(_ref4, file) {
    var participant_auth_token, auth_token, enrollment_identifier, node_slug, bucket, _yield$getUploadUrl, _yield$getUploadUrl$d, interaction_identifier, upload_url, expires_at;

    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            participant_auth_token = _ref4.participant_auth_token, auth_token = _ref4.auth_token, enrollment_identifier = _ref4.enrollment_identifier, node_slug = _ref4.node_slug, bucket = _ref4.bucket;
            _context.prev = 1;
            _context.next = 4;
            return getUploadUrl({
              participant_auth_token: participant_auth_token,
              auth_token: auth_token,
              enrollment_identifier: enrollment_identifier,
              node_slug: node_slug,
              bucket: bucket,
              object_content_type: file.type
            });

          case 4:
            _yield$getUploadUrl = _context.sent;
            _yield$getUploadUrl$d = _yield$getUploadUrl.data;
            interaction_identifier = _yield$getUploadUrl$d.interaction_identifier;
            upload_url = _yield$getUploadUrl$d.upload_url;
            expires_at = _yield$getUploadUrl$d.expires_at;
            _context.next = 11;
            return _axios["default"].put(upload_url, file, {
              headers: {
                'Content-Type': file.type
              }
            });

          case 11:
            _context.next = 13;
            return postUploadSuccess({
              interaction_identifier: interaction_identifier,
              enrollment_identifier: enrollment_identifier,
              participant_auth_token: participant_auth_token,
              auth_token: auth_token
            });

          case 13:
            return _context.abrupt("return", interaction_identifier);

          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](1);
            (0, _logger.logError)(_context.t0);
            return _context.abrupt("return", Promise.reject(_context.t0));

          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 16]]);
  }));

  return function uploadSecure(_x, _x2) {
    return _ref5.apply(this, arguments);
  };
}();

exports.uploadSecure = uploadSecure;